enum CompanyProjectStatus {
  None = -1,
  Preliminary = 0,
  Upcoming = 1,
  Ongoing = 2,
  Completed = 3
}

export default CompanyProjectStatus;
